import { Alert } from 'antd';
import { useFormikContext } from 'formik';
import useCrud from 'hooks/useCrud';
import { useCallback, useEffect, useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { DetectConflictBody } from 'services/api/oms';
import { isConfictScenarioType } from '../config';
import { FV } from './share';
import { detectConflictCompatible } from 'views/Aide/components/ConflictSaveButton';

export interface ConflictProps {
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  scenarioType: Marketing.AllScenarioType;
  isPolicy?: boolean;
}

function Conflict(props: ConflictProps) {
  const { platform, region, scenarioType, isPolicy } = props;

  const { t } = useTranslate();

  const {
    item: conflict,
    fetch,
    setItem: setConflict,
  } = useCrud({
    read: useCallback(
      (body: DetectConflictBody) => {
        return detectConflictCompatible(isPolicy || false)(body);
      },
      [isPolicy],
    ),
  });

  const { hasConflict = false, conflictTasks = [] } = conflict || {};

  const {
    values: { stores, enable, praiseTriggerPoint },
  } = useFormikContext<FV>();

  const refsCurrent = { fetch, setConflict };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    if (
      !enable ||
      !isConfictScenarioType(scenarioType) ||
      stores.length === 0 ||
      (scenarioType === 'PRAISE_REMINDER' && praiseTriggerPoint !== 'SIGNED')
    ) {
      refs.current.setConflict({
        hasConflict: false,
        conflictTasks: [],
      });

      return;
    }

    refs.current
      .fetch({
        platform,
        region,
        scenarioType,
        stores,
      })
      .catch(() => {});
  }, [platform, region, scenarioType, enable, praiseTriggerPoint, stores]);

  if (!hasConflict || !isConfictScenarioType(scenarioType)) {
    return null;
  }

  return (
    <Alert
      banner
      showIcon
      type="warning"
      message={
        {
          PRAISE_REMINDER: t(
            'aide.[物流呵护-已签收-task]中已配置买家签收后，发送已签收话术。当前开启催好评且执行节点为买家签收后，系统会同时发送催好评、已签收话术。',
            { task: conflictTasks.map(({ taskName }) => taskName).join(' | ') },
          ),
          SIGN_REMINDER: t(
            'aide.[评价管理-催好评-task]中已配置买家签收后，发送催好评话术。当前启用已签收任务时，买家签收后，系统会同时发送催好评、已签收话术。',
            { task: conflictTasks.map(({ taskName }) => taskName).join(' | ') },
          ),
        }[scenarioType]
      }
    />
  );
}

export default Conflict;
